var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckCircleV2 = function SvgCheckCircleV2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    preserveAspectRatio: "none",
    viewBox: "0 0 14.28 10.408"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check",
    clipPath: "url(#clip0_9123_26797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fill: "currentColor",
    d: "M14.035.242a.844.844 0 0 0-1.174 0l-8.31 8.2-3.14-3.1a.844.844 0 0 0-1.174 0 .796.796 0 0 0 0 1.15l3.724 3.675c.16.158.371.241.582.241a.83.83 0 0 0 .583-.241l8.909-8.775a.817.817 0 0 0 0-1.159z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9123_26797"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14.28v10.408H0z"
  })))));
};
export default SvgCheckCircleV2;